import { Button } from 'azure-devops-ui/Button';
import { Link } from 'azure-devops-ui/Link';
import React from 'react';
import { Image } from 'azure-devops-ui/Image';
import { Card } from 'azure-devops-ui/Card';
import { isMobile } from 'react-device-detect';

export interface ISignInProps {
  isSignedIn: boolean;
  login: (options: any) => void;
  signUp: (options: any) => void;
}

export default function SignIn(props: ISignInProps) {
  if (props.isSignedIn) return null;

  return (
    <div className='login flex-column flex-center justify-center'>
      <Card>
        <div className='card-content flex-column flex-center'>
          <h1 style={{ fontWeight: 'bold' }}>Please sign in or register</h1>

          <div className={`text flex-column flex-center ${isMobile && 'mobile'}`}>
            <p>
              Hey there{isMobile && ', mobile adventurer'}!👋 Welcome to the <i>web</i> version of
              Ogg.
            </p>

            {/* <br />
            <div>
              For an optimal experience with your evaluation, we highly recommend deploying Ogg within{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/ado-icon.png')} />{' '}
              </span>{' '}
              <Link href='https://marketplace.visualstudio.com/items?itemName=Intriq.ogg-4-ado'>
                Azure DevOps
              </Link> or{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/jira-icon.png')} />{' '}
              </span>{' '}
              <Link href='https://marketplace.atlassian.com/apps/1234545/ogg-enhance-the-quality-of-your-stories-using-ai'>
                Jira
              </Link>. This setup provides the greatest value to our customers.
            </div>
            <br />
            <div>
              Alternatively, you can utilise this web-based version. Please note that this option
              does not include integration with{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/ado-icon.png')} />{' '}
              </span>{' '}
              Azure DevOps or{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/jira-icon.png')} />{' '}
              </span>{' '}
              Jira and therefore offers a reduced feature set.
            </div>
            <br /> */}
            <div>
              Step in to get <b>FREE</b> access the Ogg agents such as the{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/TheCritic83x83.png')} />
              </span>{' '}
              <b>Critic</b>, the{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/TheSherpa83x83.png')} />
              </span>{' '}
              <b>Sherpa</b> or the{' '}
              <span className='v-align-middle'>
                <Image src={require('../../common/img/TheWriter83x83.png')} />
              </span>{' '}
              <b>Writer</b>.
            </div>
          </div>

          <div className='flex-row flex-center'>
            <Button
              onClick={() =>
                props.login({
                  planUid: 'wQXzdaWK',
                  planPaymentTerm: 'month',
                  skipPlanOptions: true,
                })
              }
            >
              Sign In
            </Button>
            <div style={{ width: '5px' }} />
            <Button
              primary
              onClick={() =>
                props.signUp({
                  planUid: 'wQXzdaWK',
                  planPaymentTerm: 'month',
                  skipPlanOptions: true,
                })
              }
            >
              Register
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
